import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { AgentStage } from "@/Modules/Agent/Models/Domain";

import { getUserConversations } from "@/Services/TherapyApi/Agent";
import ConversationTransformer from "@/Modules/Transformers/Agent/Conversations";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";

async function fetchUserConversationsAH(customerUuid: string) {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  if (!hasValue(customerUuid)) return undefined;

  agentStore.agentStage = AgentStage.LOADING;

  try {
    const userConversationsApi = await getUserConversations(customerUuid);
    const conversationDomain = userConversationsApi.map(ConversationTransformer.toDomain);

    agentStore.setActiveConversation(conversationDomain[0]);

    return true;
  } catch (error: unknown) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    agentStore.agentStage = null;
  }
}

export default fetchUserConversationsAH;
